export const loadData = async () => {
  try {
    let dataJson = require('./colombia.json');

    if (!Array.isArray(dataJson)) dataJson = [];

    const cityToMove = "Bogotá";
    const targetDeptName = "Bogotá DC";

    // Normalizar 'ciudades' a arrays (si vienen como objetos numerados)
    dataJson.forEach((d) => {
      if (!d.ciudades) {
        d.ciudades = [];
      } else if (!Array.isArray(d.ciudades)) {
        d.ciudades = Object.values(d.ciudades);
      }
    });

    // Remover 'Bogotá' de cualquier departamento donde aparezca
    dataJson.forEach((d) => {
      d.ciudades = d.ciudades.filter((c) => c !== cityToMove);
    });

    // Asegurar que exista el departamento 'Bogotá DC' con la ciudad 'Bogotá'
    let targetDept = dataJson.find((d) => d.departamento === targetDeptName);
    if (!targetDept) {
      dataJson.push({ departamento: targetDeptName, ciudades: [cityToMove] });
    } else if (!targetDept.ciudades.includes(cityToMove)) {
      targetDept.ciudades.push(cityToMove);
    }

    // Generar lista de ciudades (nivel plano) y ordenar con localeCompare
    const citys = dataJson.flatMap((d) => d.ciudades || []);
    const sorted = citys.sort((a, b) =>
      a.localeCompare(b, "es", { sensitivity: "base" })
    );

    return { places: dataJson, citys: sorted };
  } catch (error) {
    console.error("loadData error:", error);
    return { places: [], citys: [] };
  }
};
